import attachmentIcon from "../../../assets/icons/attachment.svg";
import styled, { keyframes } from "styled-components";

// Sweep a thin vertical stripe left → right (shorter travel)
const sweep = keyframes`
  0% { background-position: 90% 50%; }
  100%   { background-position: -90% 50%; }
`;

export const StyledMaskingText = styled.span`
  --band: ${p => p.$band || "25%"};
  --ease: ${p => p.$ease || "cubic-bezier(.45, .02, .1, .98)"};
  --speed: ${p => p.$speed || "4s"};

  font-weight: 500;
  display: inline-block;
  letter-spacing: 0.075rem;
  line-height: 1;
  position: relative;

  @media (prefers-reduced-motion: reduce) {
    &::before {
      animation: none !important;
    }
  }

  /* overlay with narrow vertical mask */
  &::before {
    content: attr(data-text);
    position: absolute;
    inset: 0;
    color: transparent;

    background-image: linear-gradient(
      100deg,
      transparent calc(50% - var(--band) / 2),
      #f2f2f2 50%,
      transparent calc(50% + var(--band) / 2)
    );
    background-size: 200% 100%;
    background-repeat: no-repeat;

    /* same duration, slower feel */
    animation: ${sweep} var(--speed) var(--ease) infinite;

    background-clip: text;
    -webkit-background-clip: text;
  }
`;

export const StyledSectionTitle = styled.h3`
  color: #0e0e2c;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  margin: 0;
`;

export const StyledSectionDescription = styled.p`
  color: #0e0e2c;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  margin: 0;

  &.input {
    color: var(--GREY, #4a4a68);
    padding-left: 16px;
    position: relative;
    margin-top: 8px;

    &.file-info {
      margin: 0;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        width: 12px;
        height: 12px;
        transform: translateY(-50%);
        background: url(${attachmentIcon}) no-repeat center / contain;
      }
    }
  }

  &.bulk-field-error {
    color: #4a4a68;
    font-size: 12px;
    font-weight: 400;
    line-height: 150%;
  }

  &.pop-confirm-modal {
    color: var(--DARK-GREY, #0e0e2c);
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  }
`;
